export const label = 'font-medium block text-base font-body text-textDark';
export const hintStyle = 'block mt-1 text-sm font-body text-textMid';
